/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import { useTranslation } from "react-i18next";

import { Dialog, MediaButton } from "components";
import { useModal } from "context/modal";

import "./GeoBlockedModal.scss";

export const GeoBlockedModal = () => {
  const { t } = useTranslation();
  const { dismissModal } = useModal();

  return (
    <Dialog
      wrapClassName="GeoBlockedModal"
      destroyOnClose
      footer={null}
      visible
      onCancel={dismissModal}
      closable={false}
    >
      <span className="GeoBlockedModal__Header">
        {t("GEOBLOCKING__BLOCKED_ASSET")}
      </span>
      <div className="GeoBlockedModal__Actions">
        <MediaButton type="button" variant="primary" onClick={dismissModal}>
          {t("GEOBLOCKING__POPUP_CANCEL")}
        </MediaButton>
      </div>
    </Dialog>
  );
};
